// ProfessionalManualAllocations.jsx

// Dependencies
import React, { useState, useEffect } from 'react';

// Services
import {
  getProfessionalManualAllocations,
  addProfessionalManualAllocation,
  deleteProfessionalManualAllocation,
} from '@/services/schedulingService';

const ProfessionalManualAllocations = ({ professionalID, onUpdate }) => {
  const [allocations, setAllocations] = useState([]);
  const [newName, setNewName] = useState('');
  const [newStart, setNewStart] = useState('');
  const [newEnd, setNewEnd] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAllocations();
  }, [professionalID]);

  async function fetchAllocations() {
    try {
      const result = await getProfessionalManualAllocations(professionalID);
      setAllocations(result || []);
    } catch (e) {
      console.error(e);
    }
  }

  async function handleAdd() {
    if (!newName || !newStart || !newEnd) return;
    setLoading(true);
    try {
      await addProfessionalManualAllocation(professionalID, newName, newStart, newEnd);
      setNewName('');
      setNewStart('');
      setNewEnd('');
      await fetchAllocations();
      if (onUpdate) onUpdate();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Delete this manual allocation?')) return;
    try {
      await deleteProfessionalManualAllocation(professionalID, id);
      await fetchAllocations();
      if (onUpdate) onUpdate();
    } catch (e) {
      console.error(e);
    }
  }

  const fmtDate = (d) => new Date(Array.isArray(d) ? d[0] : d).toLocaleDateString();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <div>
        {allocations.map(a => (
          <div key={a.ManualAllocationID} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '8px' }}>
            <span style={{ fontSize: '14px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={a.EngagementName}>
              <strong>{a.EngagementName}</strong>: {fmtDate(a.StartDate)} - {fmtDate(a.EndDate)}
            </span>
            <button title="Delete" onClick={() => handleDelete(a.ManualAllocationID)} style={{ cursor: 'pointer', color: 'red', background: 'none', border: 'none', fontWeight: 'bold' }}>✕</button>
          </div>
        ))}
        {allocations.length === 0 && (
          <div style={{ fontStyle: 'italic', color: '#666', fontSize: '14px' }}>No manual allocations</div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '5px', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Engagement name"
          value={newName}
          onChange={e => setNewName(e.target.value)}
          style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0, flex: '1 1 100%' }}
        />
        <input type="date" value={newStart} onChange={e => setNewStart(e.target.value)} style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0, flex: '1 1 120px' }} />
        <span style={{ fontSize: '12px' }}>to</span>
        <input type="date" value={newEnd} onChange={e => setNewEnd(e.target.value)} style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: 0, flex: '1 1 120px' }} />
        <button onClick={handleAdd} disabled={loading || !newName || !newStart || !newEnd} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc', cursor: 'pointer', backgroundColor: '#f0f0f0' }}>Add</button>
      </div>
    </div>
  );
};

export default ProfessionalManualAllocations;
